import axios from "axios";
import { API } from "../config";

const GA_ID = "G-KKP6ZZM4TX";

// Send to Google Analytics 4 if gtag is available
const ga = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, { ...params, send_to: GA_ID });
};

// Mirror conversion events to the GTM dataLayer (for pixels/triggers in Tag Manager)
export const pushDL = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

const track = (event, page, data) => {
  // Internal analytics (Mongo)
  axios.post(`${API}/analytics/event`, { event, page, data }).catch(() => {});
  // Mirror to GA4
  ga(event, { page_path: page, ...(data || {}) });
};

export const trackPageView = (page) => {
  // Internal (incluye origen src/utm si viene en la URL: banner aeropuerto, campañas)
  let data;
  try {
    const qs = new URLSearchParams(window.location.search);
    const src = qs.get("src"); const camp = qs.get("utm_campaign"); const source = qs.get("utm_source");
    if (src || camp || source) data = { src: src || undefined, utm_campaign: camp || undefined, utm_source: source || undefined };
  } catch {}
  axios.post(`${API}/analytics/event`, { event: "page_view", page, data }).catch(() => {});
  // GA4 native page_view (uses current location)
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: page,
      page_location: window.location.href,
      page_title: typeof document !== "undefined" ? document.title : undefined,
      send_to: GA_ID,
    });
  }
};

export const trackCoverageCheck = (municipio) => {
  track("coverage_check", window.location.pathname, { municipio });
  pushDL("coverage_check", { municipio });
};
export const trackContractStart = (plan) => track("contract_start", window.location.pathname, { plan });
export const trackContractSubmit = (plan, extras) => {
  track("contract_submit", window.location.pathname, { plan, extras_count: extras?.length || 0 });
};
export const trackCTA = (label) => track("cta_click", window.location.pathname, { label });
export const trackCall = () => track("call_click", window.location.pathname);
export const trackWhatsApp = () => track("whatsapp_click", window.location.pathname);
export const trackWhatsAppShare = (source) => track("whatsapp_share", window.location.pathname, { source });

// GA4-specific e-commerce events (Travel funnel)
export const trackTravelBeginCheckout = (plan, promo) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "begin_checkout", {
    currency: "EUR",
    value: plan?.price,
    coupon: promo || undefined,
    items: plan ? [{ item_id: plan.id, item_name: plan.name, price: plan.price, item_category: plan.zone }] : [],
    send_to: GA_ID,
  });
  pushDL("begin_checkout_dl", { currency: "EUR", value: plan?.price, item_name: plan?.name });
};

export const trackTravelPurchase = ({ orderId, value, plan, promo }) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "purchase", {
    transaction_id: orderId,
    value,
    currency: "EUR",
    coupon: promo || undefined,
    items: plan ? [{ item_id: plan.id, item_name: plan.name, price: plan.price, item_category: plan.zone }] : [],
    send_to: GA_ID,
  });
};

export const trackLead = (method, extra = {}) => {
  track("generate_lead", window.location.pathname, { method, ...extra });
  pushDL("generate_lead_dl", { method, ...extra });
};
